import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/technologies/TechnologiesClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
